import onboardingApi from '@/api/onboarding'

const state = {
  loginCodeInfo: {},
  uploadTokenInfo: {}
}

const actions = {
  loginAccount ({ commit }, userName, password) {
    return onboardingApi.loginAccount(userName, password)
  },
  getInvitationInfo ({ commit }, invitationId) {
    return onboardingApi.getInvitationInfo(invitationId)
  },
  getLoginCodeInfo ({ commit }, loginCode) {
    return onboardingApi.getLoginCodeInfo(loginCode)
  },
  createPassword ({ commit }, loginCode, password, rePassword) {
    return onboardingApi.createPassword(loginCode, password, rePassword)
  },
  getOnboardingSteps ({ commit }, questionnaireId) {
    return onboardingApi.getOnboardingSteps(questionnaireId)
  },
  getStepQuestions ({ commit }, questionnaireId, stepId, invitationId) {
    return onboardingApi.getStepQuestions(questionnaireId, stepId, invitationId)
  },
  answerQuestions ({ commit }, questionnaireId, answers, isLastPage) {
    return onboardingApi.answerQuestions(questionnaireId, answers, isLastPage)
  },
  checkOnboardingPermission ({ commit }, invitationId) {
    return onboardingApi.checkOnboardingPermission(invitationId)
  },
  forgetOnboardingPassword ({ commit }, { invitationId, email }) {
    return onboardingApi.forgetOnboardingPassword(invitationId, email)
  },
  resetOnboardingPassword ({ commit }, { invitationId, resetCode }) {
    return onboardingApi.resetOnboardingPassword(invitationId, resetCode)
  }
}

const mutations = {
  SET_UPLOAD_TOKEN (state, qiniuToken) {
    state.uploadTokenInfo = qiniuToken
  }
}

const getters = {
  getLoginCodeInfo: (state) => {
    return state.loginCodeInfo
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
